import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBJ = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m16.304 22.826 2.174 26.312c2.08.56 4.265.861 6.522.861 13.807 0 25-11.193 25-25l-33.696-2.173Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M16.304 25 18.478.861C20.558.301 22.743 0 25 0c13.807 0 25 11.193 25 25H16.304Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M0 25c0 11.55 7.834 21.27 18.478 24.138V.86C7.834 3.73 0 13.448 0 25Z"
}));
FlagBJ.displayName = 'FlagBJ';
export default withFlagWrapper(FlagBJ);
//# sourceMappingURL=index.js.map